import { Tag, Typography, Space } from "antd";

const { Text } = Typography;
const columns = [
  {
    title: "ثبت درخواست",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 130,
    sorter: true,
  },
  {
    title: "نام",
    dataIndex: "user",
    key: "user",
    width: 160,
    ellipsis: true,
  },
  {
    title: "وضعیت",
    dataIndex: "cardStatus",
    key: "cardStatus",
    sorter: true,
    width: 140,
    render: (_, { cardStatus }) => {
      const color =
        cardStatus === "ISSUING"
          ? "#3366ff"
          : cardStatus === "DELIVERING"
          ? "#ffbf00"
          : cardStatus === "DELIVERED"
          ? "#33cc33"
          : cardStatus === "DEACTIVATED"
          ? "red"
          : "red";
      return (
        <>
          <Tag color={color} key={cardStatus}>
            {cardStatus === "ISSUING"
              ? "ثبت درخواست"
              : cardStatus === "DELIVERING"
              ? "آماده تحویل"
              : cardStatus === "DELIVERED"
              ? "تحویل داده شده"
              : cardStatus === "DEACTIVATED"
              ? "غیرفعال"
              : "درخواست نشده"}
          </Tag>
        </>
      );
    },
  },
  {
    title: "توضیحات",
    dataIndex: "description",
    key: "description",
    ellipsis: true,
  },
  {
    title: "جزییات",
    dataIndex: "details",
    key: "details",
    width: 140,
  },
];

export default columns;
